/**
 * This script is the main implementation of the Graphite.js frontend framework.
 * 
 * Extension functions that use Bootstrap, bootbox, or other dependencies should go in G.helpers.js
 * 
 * DEPENDENCIES:
 * 		jQuery
 */

window.G = (function() {
	
	window.onerror = function(msg, url, lineNo, columnNo, error) {
		G.proxy('/ajax/frontenderror.ajax.php')('logError', msg, url, lineNo, columnNo, error.stack);
	}
	
	var G = {};
	
	// check for jQuery
	if(typeof $ === 'undefined') {
		throw new Error('Warning: you are trying to use graphite.js without jQuery enabled. Please check your setup.');
	}
	
	// if G doesn't exist yet, create it
	if(!window.G) {
		window.G = {};
	}
	
	/**
	 * enables all the children of an element and shows the element.
	 * This is abstracted so you can enable and show an entire form / form-group at once.
	 * e.g. A user opted in for text messages, so G.show the phone number input.
	 * e.g. A user wants a custom message instead of the options listed, so when they select the 'custom' radio,
	 * 		G.show the custom input.
	 * 
	 * @param selector the element which will be shown and all its children enabled
	 * @return void
	 */
	G.show = function(selector) {
		$(selector).find('input, textarea, select').prop('disabled', false);
		$(selector).show();
	}
	
	/**
	 * Creates a modal and returns it. For dynamic use on the frontend.
	 */
	G.createModal = function(modalID, bLarge) {
		if(!$('#' + modalID).length) {
			$('body').append('\
				<div class="modal fade" id="' + modalID + '" tabindex="-1" role="dialog">\
					<div class="modal-dialog ' + (bLarge && 'modal-lg') + '" role="document">\
						<div class="modal-content">\
						</div>\
					</div>\
				</div>\
			');
		}
		return $('#' + modalID);
	}
	
	/**
	 * disables all the children of an element and hides the element.
	 * This is abstracted so you can disable and hide an entire form / form-group at once.
	 * e.g. A user opted not to receive text messages, so G.hide the phone number input.
	 * e.g. Even though you have the option to select a custom message, a user selects one of the default options. 
	 * 		If they select an option NOT custom, then G.hide the custom input.
	 * 
	 * @param selector the element which will be hidden and all its children disabled
	 * @return void
	 */
	G.hide = function(selector) {
		$(selector).find('input, textarea, select').prop('disabled', true);
		$(selector).hide();
	}
	
	/**
	 * binds object key:value pairs to elements that have corresponding 'data-bind*' attributes.
	 * G.bind only works if you add any of the following attributes to an element:
	 * 		[data-bind=key] 			writes value of key as text to this element 
	 * 		[data-bind-src=key] 		writes value of key as the src property of this element (<img>)
	 * 		[data-bind-value=key] 		writes value of key to the val() of this element (<input>)
	 * 		[data-bind-html=key]		writes value of key as inner html of this element (<div>, <span>, etc)
	 * 		[data-bind-select=key]		selects the option with the same value as key (<select>)
	 * 		[data-bind-checked=key]		checks an element based on the boolean in key
	 * 		[data-bind-data=key]		adds jQuery data to an element, able to be retrieved later via $(selector).data()
	 * 		[data-bind-editor=key]		(if summernote installed) updates text in summernote to be value of key
	 * 
	 * e.g. you have a profile 'card' on a user page. you do an ajax for the information for this user
	 * 		and run G.bind('#profileCard', ajaxData)
	 * 	data returned:
	 * 	{
	 * 		vcName:'Freddy Coworker',
	 * 		phPhone:'123456789',
	 * 		bHappy:true,
	 * 		profileImg:'pics/happy.jpg',
	 * 	}
	 * 	element to run G.bind on:
	 * 	<div id="profileCard">
	 * 		Name: <span data-bind="vcName"></span>
	 * 		Number: <span data-bind="phPhone"></span>
	 * 		Is happy: <input type="checkbox" data-bind-checked="bHappy" />
	 * 		<img data-bind-src="profileImg" src="#"/>
	 * 	<div>
	 * 
	 * @param selector the outer selector to search in for children to bind data to
	 * @param data object of key:value pairs to bind to elements which have the 'data-bind*' attribute
	 * @return void
	 */
	G.bind = function(selector, data) {
		if(data) {
			$.each(data, function(key, value) {
				$(selector).find('[data-bind="'+key+'"]').text(value);
				$(selector).find('[data-bind-src="'+key+'"]').prop('src',value);
				$(selector).find('[data-bind-value="'+key+'"]').val(value);
				$(selector).find('[data-bind-html="'+key+'"]').html(value);
				$(selector).find('[data-bind-select="'+key+'"]').find('option[value="'+value+'"]').prop('selected', true);
				$(selector).find('[data-bind-radio="'+key+'"][value="'+value+'"]').prop('checked', true);
				$(selector).find('[data-bind-checked="'+key+'"]').prop('checked', Boolean(parseInt(value)));
				$(selector).find('[data-bind-data="'+key+'"]').data(key, value);
				if($().summernote) {
					// if summernote is installed
					$(selector).find('[data-bind-editor="'+key+'"]').summernote('reset');
					$(selector).find('[data-bind-editor="'+key+'"]').summernote('code', value);
				}
			});
		}
	}
	
	/**
	 * adds help text and success / error classes to form-groups based on children that have [data-validate=key] attributes
	 * Use with form-groups. Put data-validate="ajaxKey" in the form-group and make sure it has a '.invalid-feedback' span.
	 * 
	 * e.g. sample data object to be returned by backend AJAX, and fed into G.validate:
	 * {
	 * 		'vcName': { 
	 * 			bValid:true, 
	 * 			feedback: 'Thank you for using a real name!' 
	 * 		},
	 * 		'emlEmail': { // will make [data-validate="emlEmail"] a 'danger' form-group, and show 'feedback' as danger invalid-feedback
	 * 			bValid:false,
	 * 			feedback: 'Please use a valid email, e.g. email@example.com'
	 * 		}
	 * 		'phPhone': 'Please use a valid phone number.', // if there is only a string, then the form is considered invalid
	 * }
	 * 
	 * @param selector enclosing form / element that has validation-ready children (elements with [data-validate=key], .invalid-feedback)
	 * @param data key:value object that will determine the validity and help text of 
	 * 		can be: { key: 'help text' } // in which the key will be assumed INVALID
	 * 		OR { key: { bValid: true, feedback: 'help text' } }
	 * @return void
	 */
	G.validate = function(selector, data) {
		//Clean Slate for validation
		G.removeValidation(selector);
		if(data) {
			$.each(data, function(key, value) {
				// find the related form-group
				var formGroup = $(selector).find('[data-validate="'+key+'"]');
				if(Array.isArray(value)) {
					var bValid = value[0];
					var feedback = value[1];
				} else {
					var bValid = false;
					var feedback = value;
				}
				if(bValid) {
					formGroup
						.addClass('is-valid')
						.find('.invalid-feedback')
							.addClass('text-success')
							.text(feedback);
				} else {
					formGroup
						.addClass('is-invalid')
						.find('.invalid-feedback')
							.addClass('text-danger')
							.text(feedback);
				}
			});
		}
	}
	
	G.removeValidation = function(selector) {
		$(selector).find('.is-valid').removeClass('is-valid');
		$(selector).find('.is-invalid').removeClass('is-invalid');
		$(selector).find('.invalid-feedback.text-success').removeClass('text-success');
		$(selector).find('.invalid-feedback.text-danger').removeClass('text-danger');
		$(selector).find('.invalid-feedback').text('');
	}
	
	/**
	 * Essentially hits the back button for the user. 
	 * You can provide a fallback if the user has a non-valid 'previous page,' if not provided then defaults to '/'
	 * 
	 * @param  fallback if the client doesn't have a referrer (a 'previous page') then use this. Defaults to '/'
	 * @return void
	 */
	G.goBack = function(fallback) {
		var referrer = G.REQUEST('referrer');
		
		if(!!referrer) {
			window.location = referrer;
		} else {
			fallbackUrl = fallback || '/';
			var prevPage = window.location.href;
			window.history.go(-1);
			setTimeout(function() { 
				if (window.location.href == prevPage) {
					window.location.href = fallbackUrl; 
				}
			}, 500);
		}
	}
	
	/**
	 * Calls a .cb.php function asynchronously, and returns a jQuery Deferred Promise with the returned functions.
	 * This function requires setup on the code behind using call_user_func_array() and $_POST['action'].
	* Attach a .then() function to the jQuery Deferred Promise returned to deal with the data. Avoid using await, it slows down the page.
	 * 
	 * @param string function name
	 * @param mixed[] arguments to the function
	 * @return jQuery Deferred Promise to attach a .then() function to.
	 */
	G.view = function() {
		var myArgs = arguments;
		return $.Deferred(function(deferred) {
			var action = myArgs[0];
			var args = new Array;
			for(i in myArgs) {
				if(i != 0) {
					args.push(myArgs[i])
				}
			}
			$.ajax({
				method: 'post',
				data:{ajax:true, action:action, args:args},
				dataType: 'json'
			}).always(function(result) {
				if(result.success) {
					deferred.resolve(result.data);
				} else {
					console.error(result.data || result.responseText || result);
					deferred.reject(result.data || 'An unknown error occurred.');
				}
			})
		})
	}
	
	/**
	 * Ajax an entire form to a function on the backend, similar to G.view above.
	 * This works with files too. 
	 * The entire form object will be passed to the "action" function as a single assoc array.
	 * Files will still be in the $_FILES global.
	 * This allows you to separate different file uploads on the same page into different functions
	 * (instead of loading it all into onPOST() )
	 * NOTE that all the data of this form will be in the $_POST variable, NOT passed as an argument to the function.
	 */
	G.formToView = function(form, action, location) {
		return $.Deferred(function(deferred) {
			form = $(form).get(0);
			var formData = new FormData(form);
			formData.append('ajax', true);
			formData.append('action', action);
			$.ajax({
				url: location,
				method: 'post',
				data: formData,
				processData: false,
				contentType: false,
				cache: false,
			}).always(function(result) {
				if(result.success) {
					deferred.resolve(result.data);
				} else {
					console.error(result.data || result.responseText || result);
					deferred.reject(result.data || 'An unknown error occurred.');
				}
			})
		})
	}
	
	G.ajaxFormAndValidate = function(options) {
		return new Promise(function(resolve, reject) {
			if(!options.form) {
				console.error('Missing correct parameters for G.ajaxFormAndValidate.');
			}
			options = Object.assign({
				form: 'body',
				loading: true,
				loading_message: 'Updating...',
				ajaxFunction: '',
				ajax_location: '',
				success_message: 'Updated!',
				error_message: 'Please check over the form and try again.',
			}, options);
			var $form = $(options.form);
			if(options.loading) {
				var complete = G.progress(options.loading_message);
			}
			G.formToView($form, options.ajaxFunction, options.ajax_location)
			.then(function(data) {
				if(options.loading) {
					complete();
				}
				G.removeValidation($form);
				if(options.success_message) {
					toastr.success(options.success_message);
				}
				resolve(data);
			}, function(errors) {
				if(options.loading) {
					complete();
				}
				if(errors) {
					if(typeof errors === 'string') {
						G.removeValidation($form);
						toastr.error(errors);
					} else {
						G.validate($form, errors);
						// scroll to first error in the form
						G.scrollTo($form.find('.is-invalid').first(), 0.2);
						toastr.error(options.error_message);
					}
				} else {
					toastr.error('An error has occurred. Please try again.');
				}
				reject(errors);
			});
		});
	}
	
	G.ajaxFormOnSubmit = function(options) {
		if(!options.ajaxFunction || !options.form) {
			console.error('Missing correct parameters for G.ajaxFormOnSubmit.');
		}
		options = Object.assign({
			form: 'body',
			ajaxFunction: '',
			doFirst: function() {},
			onSuccess: function() {},
			onError: function() {},
			onFinally: function() {},
		}, options);
		var $form = $(options.form);
		$form.off('submit').submit(function(event) {
			event.preventDefault();
			options.doFirst();
			G.ajaxFormAndValidate(options)
			.then(options.onSuccess, options.onError)
			.finally(options.onFinally);
		});
		$form.off('submit').submit(function(event) {
			event.preventDefault();
			options.doFirst();
			G.ajaxFormAndValidate(options)
			.then(options.onSuccess, options.onError)
			.finally(options.onFinally);
		});
	}
	
	/**
	 * Returns a 'proxy' of the location's page
	 * This essentially allows you to run G.view, but on a completely different page.
	 * 
	 * e.g. 
	 * var proxy = G.proxy('index.php')
	 * await proxy('checklogin');
	 * 
	 * @param str location of the php file you want to AJAX your requests to (defaults to current page)
	 */
	G.proxy = function(location) {
		return function() {
			var myArgs = arguments;
			return $.Deferred(function(deferred) {
				var action = myArgs[0];
				var args = new Array;
				for(i in myArgs) {
					if(i != 0) {
						args.push(myArgs[i])
					}
				}
				$.ajax({
					url:location,
					method: 'post',
					data:{ajax:true, action:action, args:args},
					dataType: 'json'
				}).always(function(result) {
					if(result.success) {
						deferred.resolve(result.data);
					} else {
						console.error(result.data || result.responseText || result);
						deferred.reject(result.data || 'An unknown error occurred.');
					}
				});
			});
		}	
	}
	
	/**
	 * Loads a proxy that will allow you to call class functions from javascript.
	 * This function only works as a super admin.
	 * Avoid using await in js scripts, instead use proxy.myAJAXFunc().then(function() => {})
	 * 
	 * e.g.
	 * var User = G.loadClass('usersclass', 'CASH2_CLASSES');
	 * await User.GetRecord(665);
	 * 
	 * @param str resourceType 'class' or 'library'
	 * @param str resourceName name of the class/library
	 * @param bool bProfile A 'profile' proxy will show the amount of time each call took.
	 * @return Proxy object you can directly run .classFunc(), .libFunc(), etc on
	 */
	G.loadResource = function(resourceType, resourceName, bProfile) {
		resourceName = resourceName || '(default)';
		var myClass = {
			
			get: function(target, name) {
				var action = name;
				return function() {
					var myArgs = arguments;
					return $.Deferred(function(deferred) {
						var args = new Array;
						for(i in myArgs) {
							args.push(myArgs[i]);
						}
						$.ajax({
							method: 'post',
							url:'/graphitejs.php',
							data:{
								ajax:true, 
								resourceType:resourceType, 
								resourceName:resourceName, 
								action:action, 
								args:args, 
								profile:bProfile
							},
							dataType: 'json'
						}).always(function(result) {
							if(result.success) {
								deferred.resolve(result.data);
							} else {
								deferred.reject(result.data || 'An unknown error occurred.');
							}
						})
					});
				}
			}
		};
		return new Proxy({}, myClass);
	}
	
	/**
	 * Loads a Class into a frontend javascript object via the graphitejs.php / _Factory
	 * Super Admins only
	 * 
	 * @param str resourceName
	 */
	G.loadClass = function(resourceName) {
		return this.loadResource('class', resourceName);
	}
	
	/**
	 * Loads a Library into a frontend javascript object via the graphitejs.php / _Factory
	 * Super Admins only
	 * 
	 * @param str resourceName
	 */
	G.loadLibrary = function(resourceName) {
		return this.loadResource('library', resourceName);
	}
	
	/**
	 * Loads a speed profiling Class into a frontend javascript object via the graphitejs.php / _Factory
	 * Super Admins only
	 * 
	 * @param str resourceName
	 */
	G.profileClass = function(resourceName) {
		return this.loadResource('class', resourceName, true);
	}
	
	/**
	 * Loads a speed profiling Library into a frontend javascript object via the graphitejs.php / _Factory
	 * Super Admins only
	 * 
	 * @param str resourceName
	 */
	G.profileLibrary = function(resourceName) {
		return this.loadResource('library', resourceName, true);
	}
	
	/**
	 * returns the value of a REQUEST parameter from the url
	 * 
	 * e.g. 
	 * index.php?query=findme 
	 * G.REQUEST('query') // returns 'findme'
	 * 
	 * @param str key of the REQUEST parameter you want 
	 */
	G.REQUEST = function(name) {
		var url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	},
	
	/**
	 * Posts data to a specific path without AJAX (redirects to that page with POST data). 
	 * Creating a form is the easiest way to do this.
	 * 
	 * !!! IMPORTANT !!! TODO: This function does not currently POST multidimensional parameters. 
	 * 
	 * @param str path url to POST to
	 * @param obj parameters to POST
	 * @return void
	 */
	G.POST = function(path, parameters) {
		var form = $('<form></form>');
	
		form.attr("method", "post");
		form.attr("action", path);
	
		$.each(parameters, function(key, value) {
			var field = $('<input></input>');
	
			field.attr("type", "hidden");
			field.attr("name", key);
			field.attr("value", value);
	
			form.append(field);
		});
	
		// The form needs to be a part of the document in
		// order for us to be able to submit it.
		$(document.body).append(form);
		form.submit();
	}
	
	/**
	 * give a form selector, and this returns a key:value object of the form and its properties.
	 * 
	 * @param str form selector
	 */
	G.parseForm = function(form) {
		var paramObj = {};
		$.each($(form).serializeArray(), function(_, kv) {
			if(kv.name.indexOf('[') > -1) {
				var propertyPath = kv.name
									.replace(/\]\[/g, '.')
									.replace(/\]/g, '.')
									.replace(/\[/g, '.')
									.split('.');
				propertyPath.pop();
			} else {
				var propertyPath = [kv.name];
			}
			var location = paramObj; 
			propertyPath.forEach(function(segment, index) {
				if(segment == '') {
					location = location || new Array;
					location.push(kv.value)
					return;
				}
				if(index == propertyPath.length - 1) {
					location[segment] = kv.value;
					return; 
				}
				if (!location[segment]) {
					var store = propertyPath[index+1] == '' ? new Array : new Object; 
					location[segment] = store; 
				}
				location = location[segment];
			});
		});
		return paramObj;
	}
	
	var datepickers = [];
		
	G.datepicker = function(element, options){
		if(typeof $(element).attr('data-date-picker-id') !== 'undefined') {
			return datepickers[$(element).attr('data-date-picker-id')];
		} else {
			G.buildDatePicker(element, options);
		}
	}
	
	G.buildDatePicker = function(datepicker, options) {
		if(!options) {
			options = $(datepicker).attr('data-date-picker') || "{}";
			options = JSON.parse(options);
		}
		
		var picker = $(datepicker).flatpickr(options);
		var id = datepickers.push(picker)-1;
		$(datepicker).attr('data-date-picker-id', id);
		
		// setTimeout(function() {picker.setDate($(datepicker).val(), true)}, 500);
		return datepickers[id];
	}
	
	/**
	 * @see https://levelup.gitconnected.com/debounce-in-javascript-improve-your-applications-performance-5b01855e086
	 * 
	 * returns a function that will only run once after 'wait' milliseconds,
	 * no matter how many times you call it. Every call to the function will
	 * increase the timeout.
	 * 
	 * A perfect example is a search bar. You don't want to actually AJAX until 
	 * they have finished typing. So you would debounce the AJAX function with 
	 * 300 milliseconds. Then each time they type this debounce function would
	 * extend the timeout until the user lets the timeout fully elapse, in which
	 * the AJAX will be finally called.
	 * 
	 * If `immediate` is passed, then run the function immediately when called, 
	 * but don't let it run again until the timeout has elapsed.
	 */
	G.debounce = function(func, wait, immediate) {
		var timeout;
		return function() {
			// save the "this" and "arguments" of this function so we can pass it to func
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};
	
	G.scrollTo = function(selector, fractionOfScreen, duration) {
		selector = selector || 'body';
		fractionOfScreen = fractionOfScreen || 0.5;
		duration = duration || 500;
		return new Promise(function(resolve) {
			$('html, body').animate({
				scrollTop: $(selector).offset().top - ($(window).height() * fractionOfScreen),
			}, duration, undefined, resolve);
		}).catch(G.noop);
	}
	
	G.scrollToBottom = function(duration) {
		return new Promise(function(resolve) {
			$('html, body').animate({
				scrollTop: $(document).height(),
			}, duration, undefined, resolve);
		}).catch(G.noop);
	}
	
	// show a popup. wrapper for whatever popup plugin we're using.
	// in this case, SweetAlert2
	G.popup = function(title, message, type) {
		Swal.fire(title, message, type);
	}
	
	G.blankPopup = function(title, message) {
		Swal.fire({
			title: title,
			html: message,
			showConfirmButton: false,
			showCancelButton: false,
		})
	}
	
	// show a toast notification
	G.toast = function(title, message, type) {
		toastr[type](message, title);
	}
	
	G.refresh = function() {
		window.location.reload();
	}
	
	G.redirect = function(path, timeout) {
		var path = path || window.location.href;
		if(timeout) {
			setTimeout(function() {
				// this will not actually refresh the page if "path" is the current href with a # hash after.
				// but splitting / joining will force refresh.
				window.location.href = path.split(/#/, 1).join('#');
			}, timeout);
		} else {
			// this will not actually refresh the page if "path" is the current href with a # hash after.
			// but splitting / joining will force refresh.
			window.location.href = path.split(/#/, 1).join('#')
		}
	}
	
	// returns $ending if number is NOT 1 (for pluralizing words)
	// e.g. numAffiliates+G.pluralize(numAffiliates, 's');
	G.pluralize = function(intNum, ending) {
		ending = ending || 's';
		return intNum == 1 ? '' : ending;
	}
	
	G.selectpicker = function(element, options) {
		options = Object.assign({
			theme: 'bootstrap4',
		}, options);
		$(element).select2(options);
	}
	
	G.redirectWithMessage = function(message, type, path) {
		var messageProxy = G.proxy('/ajax/sessionmessages.ajax.php');
		messageProxy('setSessionMessage', message, type)
		.then(function() {
			G.redirect(path);
		})
	}
	
	G.arrayColumn = function(object, valueKey, indexKey) {
		var newObject = {};
		var count = 0;
		$.each(object, function(i, item) {
			var newItem = valueKey ? item[valueKey] : item;
			var newIndex = indexKey ? item[indexKey] : count;
			newObject[newIndex] = newItem;
			count++; 
		});
		return newObject;
	}
	
	G.genericErrorMessage = 'An error has occured. Please try again. If the problem persists, please <a href="/help#contact">contact us</a>.';
	G.genericError = function(error) {
		G.toast(error || G.genericErrorMessage, '', 'error');
	}
	
	return G;
})();